:host {
  --rzf-collapsable--background-color: #fff;
  --rzf-collapsable--border: 1px solid #ddd;
  --rzf-collapsable--border-radius: 8px;
  --rzf-collapsable--padding: 16px;

  --rzf-collapsable__title--font-size: 1.5em;
  --rzf-collapsable__title--color: #000;
  --rzf-collapsable__title--line-height: 1.2;
  --rzf-collapsable__title--white-space: normal;
  --rzf-collapsable__title--width: 55%;
  --rzf-collapsable__title--word-break: break-word;

  --rzf-collapsable__subtitle--font-size: 1em;
  --rzf-collapsable__subtitle--color: #666;
  --rzf-collapsable__subtitle--line-height: 0;

  --rzf-collapsable__toggle--color: #007bff;
  --rzf-collapsable__content--padding: 16px 0px;
  --rzf-collapsable__footer--padding: 16px 0px;
  --rzf-collapsable__divider--color: #ddd;
  --rzf-collapsable__divider--height: 2px; /* Adjust thickness here */

  --rzf-collapsable__header--align-items: center;
  display: block;
}

.rzf-collapsable {
  background-color: var(--rzf-collapsable--background-color);
  border: var(--rzf-collapsable--border);
  border-radius: var(--rzf-collapsable--border-radius);
  padding: var(--rzf-collapsable--padding);
}

.rzf-collapsable__header {
  display: flex;
  justify-content: space-between;
  align-items: var(--rzf-collapsable__header--align-items);
}

.rzf-collapsable__title-container {
  display: flex;
  flex-direction: column;
}

.rzf-collapsable__title {
  font-size: var(--rzf-collapsable__title--font-size);
  color: var(--rzf-collapsable__title--color);
  margin: 0;

  white-space: var(--rzf-collapsable__title--white-space);
  line-height: var(--rzf-collapsable__title--line-height);
  width: var(--rzf-collapsable__title--width);
  word-break: var(--rzf-collapsable__title--word-break);
}

@media (min-width: 600px) {
  .rzf-collapsable__title{
    --rzf-collapsable__title--line-height: 0;
    --rzf-collapsable__title--white-space: nowrap;
    --rzf-collapsable__title--width: auto;
    --rzf-collapsable__title--word-break: normal;
  }
}

.rzf-collapsable__subtitle {
  font-size: var(--rzf-collapsable__subtitle--font-size);
  color: var(--rzf-collapsable__subtitle--color);
  margin: 0;
  line-height: var(--rzf-collapsable__subtitle--line-height);

}

.rzf-collapsable__toggle {
  color: var(--rzf-collapsable__toggle--color);
  text-decoration: none;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  padding-right: 14px;
}

.rzf-collapsable__toggle:active {
  background: transparent;
}

.rzf-collapsable__toggle-icon {
  transition: transform 0.3s ease;
}


.rzf-collapsable__toggle-icon--collapsed ::slotted([slot="toggle"]){
  transition: transform 0.3s ease;
  transform: rotate(0deg);
}

.rzf-collapsable__toggle-icon--uncollapsed ::slotted([slot="toggle"]){
  transition: transform 0.3s ease;
  transform: rotate(135deg);
}

.rzf-collapsable__divider {
  height: var(--rzf-collapsable__divider--height);
  background-color: var(--rzf-collapsable__divider--color);
  border: none;
  margin: 16px 0;
}

.rzf-collapsable__content {
  padding: var(--rzf-collapsable__content--padding);
  transition: max-height 0.3s ease, padding 0.3s ease;
  overflow: hidden;
}

.rzf-collapsable__content--hidden {
  max-height: 0;
  padding: 0;
}

.rzf-collapsable__footer {
  padding: var(--rzf-collapsable__footer--padding);
  border-top: var(--rzf-collapsable--border);
}
